<nav
  class="navbar fixed-top navbar-expand-lg bg-info"
  color-on-scroll="100"
  id="navbar-top"
>
  <div class="container">
    <div class="navbar-translate">
      <a
        class="navbar-brand text-white"
        [routerLink]="['/home']"
      >
        <span> MEDABI • </span> Telemedicina
      </a>
      <button
        aria-controls="navigation-index"
        aria-label="Toggle navigation"
        class="navbar-toggler navbar-toggler"
        [attr.aria-expanded]="!isCollapsed"
        (click)="isCollapsed = !isCollapsed"
        id="navigation"
        type="button"
      >
        <span class="navbar-toggler-bar bar1"> </span>
        <span class="navbar-toggler-bar bar2"> </span>
        <span class="navbar-toggler-bar bar3"> </span>
      </button>
    </div>
    <div
      class="navbar-collapse justify-content-end"
      [collapse]="isCollapsed"
      id="navigation"
    >
      <div class="navbar-collapse-header">
        <div class="row">
          <div class="col-6 collapse-brand"><a> MEDABI • </a></div>
          <div class="col-6 collapse-close text-right">
            <button
              aria-controls="navigation-index"
              aria-label="Toggle navigation"
              class="navbar-toggler"
              [attr.aria-expanded]="!isCollapsed"
              (click)="isCollapsed = !isCollapsed"
              id="navigation"
              type="button"
            >
              <i class="fas fa-times"></i>
            </button>
          </div>
        </div>
      </div>
      <ul class="navbar-nav">
        <li class="nav-item p-0">
          <a class="nav-link" [routerLink]="['/home']">
            <p >Inicio <i class="fas fa-home"></i></p>
          </a>
        </li>
        <li class="nav-item p-0" *ngIf="!localId">
          <a class="nav-link" [routerLink]="['/login']">
            <p >Iniciar Sesion <i class="fas fa-user"></i></p>
          </a>
        </li>
        <li class="nav-item p-0" *ngIf="!localId">
          <a class="nav-link" [routerLink]="['/register']">
            <p >Registro <i class="far fa-user"></i></p>
          </a>
        </li>
        <li class="nav-item p-0" *ngIf="localId">
          <a class="nav-link" [routerLink]="['/admin']">
            <p><i class="fas fa-user-circle"></i></p>
          </a>
        </li>
        <li class="nav-item p-0" *ngIf="localId">
          <a (click)="singOut()" class="nav-link" [routerLink]="['/home']">
            <p><i class="fas fa-sign-out-alt"></i></p>
          </a>
        </li>
      </ul>
    </div>
  </div>
</nav>